import React, { useState, useRef, useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShapes } from '@fortawesome/free-solid-svg-icons';

import './ShapeToolButton.css';

const renderIcon = (key) => {
  switch (key) {
    case 'line':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <line x1="4" y1="20" x2="20" y2="4" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      );
    case 'arrow':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <line x1="4" y1="20" x2="18" y2="6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
          <polygon points="20,4 13,6 18,11" fill="currentColor" />
        </svg>
      );
    case 'rectangle':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <rect x="3" y="7" width="18" height="10" stroke="currentColor" strokeWidth="2.2" fill="none" />
        </svg>
      );
    case 'square':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <rect x="5" y="5" width="14" height="14" stroke="currentColor" strokeWidth="2.2" fill="none" />
        </svg>
      );
    case 'circle':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2.2" fill="none" />
        </svg>
      );
    case 'triangle':
      return (
        <svg viewBox="0 0 24 24" width="18" height="18">
          <polygon
            points="12,4 21,20 3,20"
            stroke="currentColor"
            strokeWidth="2.2"
            fill="none"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return <FontAwesomeIcon icon={faShapes} />;
  }
};

const SHAPES = [
  { key: 'line', label: 'Line' },
  { key: 'arrow', label: 'Arrow' },
  { key: 'rectangle', label: 'Rectangle' },
  { key: 'square', label: 'Square' },
  { key: 'circle', label: 'Circle' },
  { key: 'triangle', label: 'Triangle' },
];

const SHAPE_KEYS = SHAPES.map((s) => s.key);

const ShapeToolButton = ({ tool, onSelectShape }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const isShapeMode = SHAPE_KEYS.includes(tool);
  const displayKey = isShapeMode ? tool : null;

  const handleSelect = (key, event) => {
    onSelectShape(key);
    setOpen(false);
    event.stopPropagation();
  };

  return (
    <div className="shape-tool-button" ref={ref}>
      <IconButton
        onClick={() => setOpen(!open)}
        className={'sb-icon-btn' + (isShapeMode ? ' sb-icon-btn--active' : '')}
        title="Shapes"
        aria-haspopup="true"
        aria-expanded={open}
      >
        {renderIcon(displayKey)}
      </IconButton>
      {open && (
        <div className="shape-tool-button__dropdown" role="menu">
          <div className="shape-tool-button__label">Shape</div>
          <div className="shape-tool-button__grid">
            {SHAPES.map((s) => (
              <button
                key={s.key}
                type="button"
                onClick={(event) => handleSelect(s.key, event)}
                className={'shape-tool-button__item' + (tool === s.key ? ' active' : '')}
                title={s.label}
                aria-label={s.label}
                role="menuitem"
              >
                {renderIcon(s.key)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShapeToolButton;
export { SHAPE_KEYS };
